var _style, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDoDoblackTagline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 429.2 154.9",
    width: 150,
    height: 68,
    style: {
      enableBackground: "new 0 0 429.2 154.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0 {\n\t\t\tfill: #FFFFFF;\n\t\t}\n\n\t\t.st1 {\n\t\t\tfill: #1D1D1B;\n\t\t}\n\t")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 429.2,
    height: 154.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M341.7,54.5c3.7,1.5,7,3.6,9.7,6.2c2.8,2.6,4.9,5.6,6.4,9.1c1.5,3.5,2.3,7.1,2.3,10.9c0,4-0.8,7.6-2.3,11.1 c-1.5,3.5-3.7,6.5-6.4,9.1c-2.8,2.6-5.9,4.7-9.7,6.2c-3.7,1.5-7.7,2.2-12.1,2.2s-8.4-0.7-12.1-2.2c-3.7-1.5-7-3.5-9.7-6.2 c-2.8-2.6-4.9-5.6-6.4-9.1s-2.3-7.1-2.3-11.1c0-3.8,0.8-7.5,2.3-10.9c1.5-3.5,3.7-6.5,6.4-9.1c2.8-2.6,5.9-4.7,9.7-6.2 c3.7-1.5,7.7-2.3,12.1-2.3S338.1,53,341.7,54.5z M337.3,105.2c1.9-1.5,3.1-3.6,4.1-6.1c0.9-2.4,1.4-5.4,1.6-8.6 c0.2-3.3,0.3-6.5,0.3-9.9s-0.1-6.6-0.3-9.8c-0.2-3.3-0.7-6.1-1.6-8.6c-0.9-2.4-2.2-4.5-4.1-6.1s-4.4-2.3-7.7-2.3 s-5.8,0.8-7.6,2.3c-1.9,1.5-3.1,3.6-4.1,6.1c-0.9,2.4-1.4,5.4-1.6,8.6c-0.2,3.3-0.3,6.5-0.3,9.8c0,3.4,0.1,6.6,0.3,9.9 c0.2,3.3,0.7,6.2,1.6,8.6c0.9,2.4,2.2,4.5,4.1,6.1c1.9,1.5,4.4,2.3,7.6,2.3S335.5,106.9,337.3,105.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.4,106.1c4.4-0.2,7.6-0.3,11.2-0.5c0-27.8,0-55.4,0-83.4c-3.4-0.2-6.6-0.6-10.7-0.8c0.9-1,1.3-1.6,1.6-1.6 c18.6,0.2,37.5-0.7,56,1.3c22.5,2.3,36.5,20.4,36.3,43.6c-0.1,22.2-14.9,40.4-37,42.5c-18.4,1.7-36.9,0.8-55.4,1 C208.3,108,208,107.6,206.4,106.1z M239.2,105.8c4,0,7.5,0.1,10.9,0c16.4-0.6,24.7-6.6,26.6-22.8c1.5-14,0.6-28.3-0.3-42.5 c-0.5-6.6-4.2-12.6-10.8-15.6c-8.4-4-17.2-3-26.2-2.6C239.2,50.2,239.2,77.5,239.2,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1,106.1c4.4-0.2,7.6-0.3,11.2-0.5c0-27.8,0-55.4,0-83.4c-3.4-0.2-6.6-0.6-10.7-0.8c0.9-1,1.3-1.6,1.6-1.6 c18.6,0.2,37.5-0.7,56,1.3c22.5,2.3,36.5,20.4,36.3,43.6c-0.1,22.2-14.9,40.4-37,42.5c-18.4,1.7-36.9,0.8-55.4,1 C71,108,70.7,107.6,69.1,106.1z M101.8,105.8c4,0,7.5,0.1,10.9,0c16.4-0.6,24.7-6.6,26.6-22.8c1.5-14,0.6-28.3-0.3-42.5 c-0.5-6.6-4.2-12.6-10.8-15.6c-8.4-4-17.2-3-26.2-2.6C101.8,50.2,101.8,77.5,101.8,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.2,109.6c-12.2,0-20.8-7.8-21.8-19.8c-1.5-18.6,14.7-36.9,33.2-37.6c15.8-0.6,26.1,10.8,23.8,26.6 C214.5,96.4,199.6,109.6,182.2,109.6z M174.2,98.7c-0.3,6.9,3.7,10.8,10.1,8.5c3.5-1.3,7.5-4.9,8.7-8.3 c4.2-12.1,7.5-24.5,10.5-36.9c1.4-5.8-2.6-9.7-8.5-8.2c-3,0.8-7.1,3-8.2,5.7C181.7,72.3,173.7,98.5,174.2,98.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.9,130.5L69.9,130.5c0-2.6,1.9-4.7,4.7-4.7c1.7,0,2.7,0.6,3.5,1.4l-1,1.2c-0.7-0.7-1.5-1.1-2.5-1.1 c-1.7,0-3,1.4-3,3.2v0c0,1.8,1.3,3.2,3,3.2c1.1,0,1.8-0.4,2.6-1.2l1,1c-0.9,1-2,1.6-3.7,1.6C71.9,135.2,69.9,133.1,69.9,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.7,126h1.6v3.8h4.3V126h1.6v9h-1.6v-3.8h-4.3v3.8h-1.6V126z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.5,125.9h1.5l4,9.1h-1.7l-0.9-2.2h-4.3l-0.9,2.2h-1.6L112.5,125.9z M114.8,131.4l-1.6-3.6l-1.5,3.6H114.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.3,126h4c1.1,0,2,0.3,2.6,0.9c0.5,0.5,0.7,1.2,0.7,1.9v0c0,1.5-0.9,2.4-2.1,2.7l2.4,3.4h-1.9l-2.2-3.1h-2 v3.1h-1.6V126z M133.2,130.4c1.1,0,1.9-0.6,1.9-1.5v0c0-1-0.7-1.5-1.9-1.5h-2.3v3H133.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.4,126h1.7l2.7,4.3l2.7-4.3h1.7v9h-1.6v-6.5l-2.9,4.3h-0.1l-2.8-4.2v6.4h-1.6V126z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.5,126h1.6v9h-1.6V126z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.4,126h1.5l4.8,6.2V126h1.6v9h-1.3l-5-6.4v6.4h-1.6V126z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203,130.5L203,130.5c0-2.6,1.9-4.7,4.7-4.7c1.6,0,2.5,0.4,3.5,1.2l-1,1.2c-0.7-0.6-1.4-1-2.5-1 c-1.7,0-2.9,1.5-2.9,3.2v0c0,1.9,1.2,3.2,3.1,3.2c0.9,0,1.6-0.3,2.2-0.7v-1.7h-2.3V130h3.8v3.8c-0.9,0.8-2.2,1.4-3.8,1.4 C204.8,135.2,203,133.1,203,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.1,133.7l1-1.1c0.5,0.7,1.1,1.1,1.8,1.1c0.9,0,1.4-0.6,1.4-1.8V126h1.6v6c0,1.1-0.3,1.9-0.9,2.4 c-0.5,0.5-1.3,0.8-2.2,0.8C237.6,135.1,236.7,134.5,236.1,133.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254,126h6.7v1.4h-5.1v2.3h4.5v1.4h-4.5v2.4h5.2v1.4H254V126z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.8,126h1.7l2.2,6.7l2.2-6.7h1.3l2.2,6.7l2.2-6.7h1.7l-3.1,9.1h-1.4l-2.2-6.5l-2.2,6.5h-1.4L271.8,126z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.7,126h6.7v1.4h-5.1v2.3h4.5v1.4h-4.5v2.4h5.2v1.4h-6.8V126z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.2,126h1.6v7.6h4.7v1.4h-6.3V126z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333,126h4c1.1,0,2,0.3,2.6,0.9c0.5,0.5,0.7,1.2,0.7,1.9v0c0,1.5-0.9,2.4-2.1,2.7l2.4,3.4h-1.9l-2.2-3.1h-2 v3.1H333V126z M336.9,130.4c1.1,0,1.9-0.6,1.9-1.5v0c0-1-0.7-1.5-1.9-1.5h-2.3v3H336.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.4,131.4l-3.6-5.5h1.9l2.5,4l2.6-4h1.8l-3.6,5.4v3.6h-1.6V131.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDoDoblackTagline);
export default __webpack_public_path__ + "static/media/Logo DoDo black - tagline.cc6441c71949157926fba4d64befe127.svg";
export { ForwardRef as ReactComponent };